import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/home',
            name: 'home',
            component: () => import('./views/Home.vue'),
            children: [
                {
                    path: '/about',
                    name: 'about',
                    meta: {
                        title: 'permission', icon: 'el-icon-menu', roles: ['Admin']
                    },
                    component: () => import('./views/About.vue')
                },
                {
                    path: '/user',
                    name: 'user',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/user/UserIndex.vue')
                },
                {
                    path: '/user/update/:id',
                    name: 'userUpdate',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/user/UserUpdate.vue')
                },
                {
                    path: '/brand',
                    name: 'brand',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/brand/BrandIndex.vue')
                },
                //品牌
                {
                    path: '/brand/add',
                    name: 'brandAdd',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/brand/BrandAdd.vue')
                },
                {
                    path: '/brand/update/:id',
                    name: 'brandUpdate',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/brand/BrandUpdate.vue')
                },
                //商品
                {
                    path: '/product',
                    name: 'product',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/product/ProductIndex.vue')
                },

                {
                    path: '/product/add',
                    name: 'productAdd',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/product/ProductAdd.vue')
                },
                {
                    path: '/product/update/:id',
                    name: 'productUpdate',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/product/ProductUpdate.vue')
                },
                //生成厂商
                {
                    path: '/manufacturer',
                    name: 'manufacturer',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/manufacturer/ManufacturerIndex.vue')
                },

                {
                    path: '/manufacturer/add',
                    name: 'manufacturerAdd',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/manufacturer/ManufacturerAdd.vue')
                },
                {
                    path: '/manufacturer/update/:id',
                    name: 'manufacturerUpdate',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/manufacturer/ManufacturerUpdate.vue')
                },
                //产品分类
                {
                    path: '/productGroup',
                    name: 'productGroup',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/productGroup/ProductGroupIndex.vue')
                },

                {
                    path: '/productGroup/add',
                    name: 'productGroupAdd',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/productGroup/ProductGroupAdd.vue')
                },
                {
                    path: '/productGroup/update/:id',
                    name: 'productGroupUpdate',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/productGroup/ProductGroupUpdate.vue')
                },
                // Event
                {
                    path: '/event',
                    name: 'event',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/event/EventIndex.vue')
                },
                {
                    path: '/event/add',
                    name: 'eventAdd',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/event/EventAdd.vue')
                },
                {
                    path: '/event/update/:id',
                    name: 'eventUpdate',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/event/EventUpdate.vue')
                },
                {
                    path: '/event/add/product/:id',
                    name: 'eventAddProduct',
                    meta: {
                        roles: ['Admin']
                    },
                    component: () => import('./views/event/EventAddProduct.vue')
                },

            ]
        },

        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/404',
            name: '404',
            component: () => import('./views/Login.vue')
        },
        {
            path: '*',
            redirect: '/login'
        },


    ]


})
